<div class="label-list-wrap">
    <span *ngIf="labelsList.length" class="label user-group-label">{{labelsList[0][keyName]}}</span>

    <span *ngIf="labelsList.length > 1" (click)="toggle($event);"  class="label show-labels">...</span>
    <div [style.display]="isShowAllLabels ? 'block' : null" class="popover bottom">
        <div class="arrow"></div>

        <div class="popover-content">
            <span *ngFor="let label of labelsList | slice:1" class="label user-group-label">{{label[keyName]}}</span>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// /app/src/app/components/labels-list/labels-list.component.html